<div #tgChartContainer class="turf-guard-chart-container">
    <highcharts-chart *ngIf="chartOptions"  [Highcharts]="Highcharts" [options]="chartOptions">
    </highcharts-chart>
</div>
